import { currentAppEnvironment } from '@savgroup-front-common/constants/shared';

import {
  BASE_LATENCY_WEIGHT_RULES,
  DEFAULT_LATENCY_WEIGHT,
  LATENCY_WEIGHT_RULES_BY_ENV,
  LatencyWeightRule,
} from './latencyWeighting.constants';

export const ACTIVE_LATENCY_WEIGHT_RULES: LatencyWeightRule[] = [
  ...(LATENCY_WEIGHT_RULES_BY_ENV[currentAppEnvironment] ?? []),
  ...BASE_LATENCY_WEIGHT_RULES,
];

export const matchLatencyWeight = ({
  url,
  rules,
}: {
  url?: string;
  rules: LatencyWeightRule[];
}): number => {
  if (!url) {
    return DEFAULT_LATENCY_WEIGHT;
  }

  const matchedRule = rules.find((rule) => rule.pattern.test(url));

  if (!matchedRule) {
    return DEFAULT_LATENCY_WEIGHT;
  }

  return Math.max(0, matchedRule.weight);
};

export const resolveLatencyWeight = (url?: string): number => {
  return matchLatencyWeight({ url, rules: ACTIVE_LATENCY_WEIGHT_RULES });
};
